import React, { Memo, useContext, useEffect } from "react";
import { Redirect, Link, NavLink } from "react-router-dom";
import $ from "jquery";
import PsContext from "../../../context/PsContext";
import LOGO from "../../../assets/img/footer-shibani.png";
import PAY1 from "../../../assets/img/payments/1.png";
import PAY2 from "../../../assets/img/payments/2.png";
import PAY3 from "../../../assets/img/payments/3.png";
import PAY4 from "../../../assets/img/payments/4.png";
import PAY5 from "../../../assets/img/payments/6.png";
import WP from "../../../assets/img/whatsapp.png";
const Footer = () => {
  const context = useContext(PsContext);

  const d = context.state.company;

  const topCategories = [
    { text: "Festival", to: "/category/festival" },
    { text: "Semi Stiched Lehanga", to: "/category/semi-stitched-lehenga" },
    { text: "Wedding Collections", to: "/category/wedding" },
    { text: "Receptions", to: "/category/receptions" },
    { text: "Bridal", to: "/category/bridal" },
  ];

  return (
    <footer id="footer-1" className="footer-1 footer mt-50">
      <div className="whatsapp-icon">
        <a
          href="https://wa.me/6374327362"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={WP} alt="WhatsApp" />
        </a>
      </div>
      <div className="footer-wrap">
        <div className="footer-body p-0 m-0">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-md-6 col-12">
                <div className="footer-infor">
                  <div className="footer-logo mt-50">
                    <Link to="/">
                      <a href="" className="">
                        <img
                          src={LOGO}
                          alt="Logo"
                          style={{ width: "130px" }}
                          className="logo tf-md-hidden"
                        />
                        <h4
                          className="tf-lg-hidden"
                          style={{ fontSize: "20px", fontWeight: "bolder" }}
                        >
                          Shibani Fashion
                        </h4>
                      </a>
                    </Link>
                  </div>
                  <ul className=" pt-sm-0">
                    <li>
                      <p style={{ fontSize: "14px" }} className="mb-5">
                        Address:
                        <a href="#">
                          No.1, Market Road, Colachel, Tamil Nadu 629251
                        </a>
                      </p>
                    </li>
                    <li>
                      <p
                        style={{ fontSize: "14px", textAlign: "justify" }}
                        className="mb-5"
                      >
                        Email: <a href="#">shibanifashion2015@gmail.com</a>
                      </p>
                    </li>
                    <li>
                      <p
                        style={{ fontSize: "14px", textAlign: "justify" }}
                        className="mb-5"
                      >
                        Phone: <a href="#">6374327362, 84800 80064</a>
                      </p>
                    </li>
                  </ul>
                  <div class="tf-payment">
                    <img src={PAY1} />
                    <img src={PAY2} />
                    <img src={PAY3} />
                    <img src={PAY4} />
                    <img src={PAY5} />
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-6">
                <div className="single-footer f-link">
                  <h3>Information</h3>
                  <ul>
                    <li>
                      <Link to="/terms">Terms and Condition</Link>
                    </li>
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/refund-policy">Refund Policy</Link>
                    </li>
                    <li>
                      <Link to="/shipping-policy">Shipping Policy</Link>
                    </li>
                    <li>
                      <Link to="/disclaimer">Disclaimer</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-6">
                <div className="single-footer f-link">
                  <h3>Top Categories</h3>
                  <ul>
                    {topCategories.map((item) => (
                      <li>
                        <Link to={item.to}>{item.text}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-lg-5 col-md-6 col-12">
                <div className="single-footer f-link">
                  <h3>Location</h3>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d126374.82835087663!2d77.3416901!3d8.1812467!3m2!1i1024!2i768!4f13.1!2m1!1sshibani%20fashion!5e0!3m2!1sen!2sin!4v1743745722069!5m2!1sen!2sin"
                    style={{ border: "0", width: "100%", height: "220px" }}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container-fluid">
          <div className="inner-content">
            <div className="row align-items-center">
              <div className="col-lg-4 col-12 pb-0">
                <div className="copyrights d-flex justify-content-center">
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                    }}
                    className="mb-2 text-start"
                  >
                    &copy; 2025 All Right Reserved{" "}
                    <a
                      href="#"
                      title="Peace Soft Technology"
                      className="ms-20 text-theme"
                    >
                      Shibani Fashion
                    </a>
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-12 pb-0">
                <div className="copyrights d-flex justify-content-center">
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                    }}
                    className="mb-2 text-center"
                  >
                    Designed and Developed by{" "}
                    <a
                      href="https://peacesoft.in"
                      title="Peace Soft Technology"
                      target="_blank"
                      className="ms-20 text-theme"
                    >
                      Peacesoft Technologies
                    </a>
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-12 text-right footer_ps_links ">
                <div className="tf-top-bar_wrap grid-3 gap-30 d-flex justify-content-end">
                  <ul className="tf-top-bar_item tf-social-icon d-flex gap-10  align-items-end">
                    <li>
                      <a
                        href="https://www.facebook.com/share/1A5Riicaq3/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="box-icon w_28 round social-facebook bg_line"
                      >
                        <i className="icon fs-12 icon-fb"></i>
                      </a>
                    </li>
                    {/* <li>
                      <a
                        href="#"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="box-icon w_28 round social-twiter bg_line"
                      >
                        <i className="icon fs-10 icon-Icon-x"></i>
                      </a>
                    </li> */}
                    <li>
                      <a
                        href="https://wa.me/6374327362"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="box-icon w_28 round social-whatsapp bg_line"
                      >
                        <i className="icon fs-12 icon-whatsapp"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/shibanifashion?utm_source=qr&igsh=MWNhNTJrY2ZybGx4eQ=="
                        target="_blank"
                        rel="noopener noreferrer"
                        className="box-icon w_28 round social-instagram bg_line"
                      >
                        <i className="icon fs-12 icon-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://youtube.com/@shibanifashion2015?si=INPYFWdXAXzdD6yB"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="box-icon w_28 round social-pinterest bg_line "
                      >
                        <i className="icon fs-12 icon-youtube"></i>
                      </a>
                    </li>
                    {/* <li>
                      <a
                        href="#"
                        className="box-icon w_28 round social-pinterest bg_line"
                      >
                        <i className="icon fs-12 icon-pinterest-1"></i>
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
